export default __webpack_public_path__ + "static/media/110_mobile.aeea78fa.jpg";